import React, { useState, useEffect, useContext } from 'react';
import { Link, navigate } from 'gatsby';
import {
  toSignIn,
  toJobSearchJobDetail,
  toGetStarted,
  toTermsOfService,
} from '../../routes';
import agent from '../../agent';

import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';
import {
  JobSearchContext,
  JobSearchContextType,
} from '../../context/JobSearchContext';
import { GlobalContext } from '../../context/GlobalContext';

const ReportJobForm = (props) => {
  const {
    jobId,
    flagType,
    isThirdParty,
    reportJobModalOpen,
    setReportJobModalOpen,
  } = props;
  const {
    userAuth: { isAuthenticated },
    updateRedirectPath,
  } = useContext(GlobalContext);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [currentFlag, setCurrentFlag] = useState('');
  const { updatePremiumJob, updatePartnerJob } = useContext(
    JobSearchContext
  ) as JobSearchContextType;

  const reasonCodes = [
    { code: 'FRAUD', label: 'Scam/Fraud' },
    { code: 'DUPLICATE', label: 'Duplicate Posting' },
    { code: 'INACCURATE', label: 'Inaccurate' },
    { code: 'OFFENSIVE', label: 'Offensive' },
  ];

  useEffect(() => {
    setErrorMessage('');
    if (!!flagType) {
      setCurrentFlag(flagType);
      if (flagType !== 'NONE') {
        setSuccessMessage(
          `You have already flagged this job posting as ${
            reasonCodes.filter((reason) => reason.code === flagType)[0]['label']
          }.`
        );
      }
    }
  }, [jobId]);

  function toggleModal() {
    setReportJobModalOpen((prev) => !prev);
  }

  function flagJob(e) {
    const value = e.target.value;
    setCurrentFlag(value);
    const body = { flagType: value };
    agent.Jobs.updateUserJobFlag({ jobId, body })
      .then((res) => {
        if (isThirdParty) {
          updatePartnerJob({ ...res.data, ...body });
        } else {
          updatePremiumJob({ ...res.data });
        }
        setSuccessMessage(
          `Thank you, this job has been flagged as ${
            reasonCodes.filter(
              (reason) => reason.code === res.data.flagType
            )[0]['label']
          } for our customer service department to review.`
        );
      })
      .catch((err) => {
        setErrorMessage(err.message);
      });
  }

  function removeFlag() {
    const body = { flagType: 'UNFLAG' };
    agent.Jobs.updateUserJobFlag({ jobId, body })
      .then((res) => {
        setCurrentFlag('NONE');
        if (isThirdParty) {
          updatePartnerJob({ ...res.data, flagType: 'NONE' });
        } else {
          updatePremiumJob({ ...res.data });
        }
      })
      .catch((err) => {
        setErrorMessage(err.message);
      });
  }

  if (!isAuthenticated) {
    return (
      <Modal
        isOpen={reportJobModalOpen}
        toggle={() => setReportJobModalOpen((prev) => !prev)}
      >
        <ModalHeader>Sign In Or Register</ModalHeader>
        <ModalBody>
          You must{' '}
          <span
            className="link-primary dp-cursor-pointer"
            onClick={() => {
              updateRedirectPath(`${toJobSearchJobDetail(jobId)}`);
              navigate(toSignIn);
            }}
          >
            sign in{' '}
          </span>
          or{' '}
          <span
            className="link-primary dp-cursor-pointer"
            onClick={() => {
              updateRedirectPath(`${toJobSearchJobDetail(jobId)}`);
              navigate(toGetStarted);
            }}
          >
            register{' '}
          </span>
          before you can perform this action.
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => setReportJobModalOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <Modal isOpen={reportJobModalOpen} toggle={toggleModal} scrollable>
      <ModalHeader toggle={toggleModal}>Report this job as...</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup tag="fieldset">
            <Col className="d-flex flex-column ps-4">
              {reasonCodes.map((reason) => {
                return (
                  <Label key={reason.code}>
                    <Input
                      type="radio"
                      name="reasonCode"
                      value={reason.code}
                      checked={currentFlag === reason.code}
                      onChange={flagJob}
                      className="me-2"
                    ></Input>
                    {reason.label}
                  </Label>
                );
              })}
            </Col>
          </FormGroup>
          <Alert isOpen={!!errorMessage} color="danger">
            {errorMessage}
          </Alert>
          <Alert
            isOpen={!!successMessage && !!currentFlag && currentFlag !== 'NONE'}
            color="secondary"
          >
            {successMessage} If this was an error, you may
            <span
              className="link-primary dp-cursor-pointer"
              style={{ verticalAlign: 'baseline' }}
              onClick={removeFlag}
            >
              {' '}
              remove flag.
            </span>
          </Alert>
        </Form>
      </ModalBody>
      <ModalFooter>
        <small>
          All Job Postings are subject to DentalPost's{' '}
          <Link to={toTermsOfService}>Terms of Service</Link>. We allow users to
          flag postings that may be in violation of those terms.
        </small>
      </ModalFooter>
    </Modal>
  );
};

export default ReportJobForm;
